<template>
    <div id="auditStatus">
        <Headers :headersText='headersText'></Headers>
        <!-- 状态栏 -->
        <div class="statusTop">
            <div class="topPanel">
                <div class="panelLeft">
                    <img :src="statusData.icon" alt="">
                    <div class="titAndTime">
                        <span class="tit">{{statusData.name}}</span>
                        <span class="time">{{sub_time}}提交审核</span>
                    </div>
                </div>
                <div class="panelRight">审核中</div>
            </div>
        </div>
        <!-- 步骤 -->
        <div class="boxs">
            <div class="step" v-for="(item,index) in statusData.step" :key="index">
                <div class="title">{{item.name}}</div>
                <div class="explain">
                    <span>{{item.des}}</span>
                </div>
                <div class="diagram">
                    <img :src="datas.url"  v-preview="datas.url" alt=""  v-for="(datas,nums) in item.url" :key="nums">
                </div>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import Headers from '../components/headersL'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'审核状态',
                imgs:require('../assets/images/img_70.png'),

                statusData:{}, // 审核页面数据
                sub_time:"", // 审核提交时间
            }
        },
        mounted() {
            // console.log(this.$route.query.ids);
            this.init();
        },
        methods: {
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('volume_task/detail',datas,(res)=>{
                    this.$loading(false);
                    this.statusData = res.data;
                    this.sub_time = res.data.evolve.sub_time
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    #auditStatus{
        // 状态栏
        .statusTop{
            width:375px;
            height:27px;
            padding-top: 8px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .topPanel{
                width:325px;
                height:40px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 0 15px;
                padding: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .panelLeft{
                    display: flex;
                    img{
                        width:40px;
                        height:40px;
                        margin-right: 10px;
                        border-radius: 12px;
                    }
                    .titAndTime{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        .tit{
                            font-size:17px;
                            font-weight:600;
                            color:rgba(21,21,21,1);
                            line-height:17px;
                        }
                        .time{
                            font-size:11px;
                            font-weight:400;
                            color:rgba(153,153,153,1);
                            line-height:11px;
                        }
                    }
                }
                .panelRight{
                    font-size:20px;
                    font-family:Arial, Helvetica, sans-serif;
                    color:rgba(230,9,26,1);
                    line-height:20px;
                    font-weight: 600;
                    margin-right: 5px;
                }
            }
        }
        // 步骤
        .boxs{
            padding: 48px 15px 15px;
            .step{
                width:315px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.6);
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0 15px;
                &:not(:first-of-type){
                    margin-top: 15px;
                }
                .title{
                    width:130px;
                    height:32px;
                    background:rgba(249,249,249,1);
                    border-radius:0px 0px 8px 8px;
                    border:1px solid rgba(222,222,222,.6);
                    font-size:13px;
                    font-weight:600;
                    color:rgba(102,102,102,1);
                    line-height:32px;
                    text-align: center;
                    margin-top: -1px;
                }
                .explain{
                    font-size:13px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:20px;
                    margin-top: 20px;
                }
                .diagram{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    margin: 10px 0;
                    img{
                        width:90px;
                        height:160px;
                        padding: 0 7px 15px;
                    }
                }
            }
        }
        
    }
</style>